import styles from './trustpilot.module.scss';

import Image from 'next/image';

type TrustpilotStarsProps = {
    logo?: string;
};

const TrustpilotStars = ({ logo }: TrustpilotStarsProps) => {
    // Turning off trustpilot until we get the better reviews
    // https://get-mosh.atlassian.net/browse/MSH-2201
    return null;

    const TrustpilotLogoColour = '/images/icons/trustpilot-logo-colour.svg';
    const TrustpilotLogoInverted = '/images/icons/trustpilot-logo-inverted.svg';
    const resolveLogo =
        logo === 'white' ? TrustpilotLogoInverted : TrustpilotLogoColour;
    return (
        <div
            className={`${styles['wrapper']} mx-auto flex items-center justify-center gap-x-3 space-x-3 py-4`}
        >
            <p className="mb-0">Excellent</p>
            <Image
                className=""
                src={'/images/icons/trustpilot-stars-colour.svg'}
                width={103}
                height={20}
                data-trustpilot="stars"
                alt="Trustpilot stars"
            />
            <Image
                src={resolveLogo}
                data-trustpilot="logo-star"
                width="80"
                height="20"
                alt="Trustpilot logo"
            />
        </div>
    );
};

export default TrustpilotStars;
